import { Divider, Flex, Typography } from "antd";
import styled from "styled-components";

const { Title } = Typography;

export const StyledAppPageHeader = styled(Flex)`
  width: 100%;
  margin-bottom: 16px;
  .app-breadcrumbs-page-header {
    margin-bottom: 0px !important;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}px) {
    margin-bottom: 8px;
  }
`;

export const StyledAppPageHeaderTitle = styled(Title)`
  font-size: 24px !important;
  width: 100%;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}px) {
    font-size: 20px !important;
  }
`;

export const StyledAppPageHeaderDivider = styled(Divider)`
  margin: 0px;
  border-block-start-color: ${({ theme }) => theme.palette.borderColor.default};
`;
